import Component from '@ember/component';
import classic from 'ember-classic-decorator';

@classic
export default class SharedImageCropModal extends Component {
  get destinationElement() {
    return document.getElementById('modal-destination') || document.body;
  }
}
